module.exports = __webpack_public_path__ + "media/images/icon/building-61c01f44833a4041bce6de32aec7ca75.svg";